import axios from "axios";
import { env } from "@/shared/config/env";
import { attachAuthInterceptor } from "./authInterceptor";

// Investigator owns its admin pages and calls the shared backend directly.
const rmsClient = axios.create({
  baseURL: env.api.rms,
  headers: { "Content-Type": "application/json" },
  timeout: 35_000,
});

attachAuthInterceptor(rmsClient);

export default rmsClient;
